import React, { Component } from 'react';
import { MyContext } from '../../../context';
import { Stack, PrimaryButton, Spinner, TextField, Icon, IconButton } from 'office-ui-fabric-react';
import { queryAllAIAssistantQuestions } from '../AIQuestion/AIQuestionQuery';
import AIAssistantQuestionsSelector from '../AIAssistant/AIAssistantQuestionsSelector';
import gql from 'graphql-tag';
import AIAssistantIcon from './AIAssistantIcon';
import AIDisclaimer from '../../common/AIDisclaimer';


export default class AIAssistantCard extends Component {

    static contextType = MyContext

    constructor(props) {
        super(props);
        this.state = {
            selectedKey: [],
            aiAssistantRes: [],
            aIAssistantSelectedQuestions: "",
            aiAssistantAnswer: "",
            openQuestion: "",
            loadingOpenAI: false,
            aIAssistantQuestion: "",
            dropdownQuerySuccesful: false
        }
    }
    //TODO this call to the backend seems unnecessary. Should it be removed?
    componentDidMount() {
        //TODO change query, needs to use the new query to get the AIAssistantQuestions on demand
        let aIQuestionType = "AIAssistantQuestion"
        this.props.apol
            .query({
                query: queryAllAIAssistantQuestions,
                variables: { aIQuestionType }
            })
            .then((result) => {
                var aiAssistantRes = result.data.getAIQuestionNames.map(r => {
                    return {
                        "key": r.id,
                        "text": r.name
                    }
                })
                aiAssistantRes = [{ "key": "-1", "text": this.context.getTranslation("compliance", "aIAssistantOpenQuestion") }, ...aiAssistantRes]
                this.setState({
                    aiAssistantRes
                })
            });
    }

    onChangeAIAssistantQuestions = (newSelection) => {
        this.setState({
            aIAssistantSelectedQuestions: newSelection,
            aiAssistantAnswer: "",
            openQuestion: ""
        })
    }

    setQuestion = (question) => {
        this.setState({
            aIAssistantQuestion: question
        })
    }

    queryHasFinished = (ended) => {

        this.setState({
            dropdownQuerySuccesful: ended
        })


    }

    askAssistant = async () => {
        this.setState({ loadingOpenAI: true })
        var data = await this.props.apol
            .query({
                query: gql`
                query ent ($input: AuthInput, $id : ID!, $question: String, $aiQuestionId: String) {
                    getOpenAIQuery (input: $input, id: $id, question: $question, aiQuestionId: $aiQuestionId) 
                    
                }
                `,
                fetchPolicy: "network-only",
                variables: {
                    id: this.props.convData.conversationId, question: this.state.openQuestion, aiQuestionId: this.state.aIAssistantSelectedQuestions != "-1" ? this.state.aIAssistantSelectedQuestions : null, input: this.props.authorization
                }
            });

        var res = data.data.getOpenAIQuery;
        //check possible error
        if ("aiException" === res) {
            res = this.context.getTranslation("openAI", "aiException")
        } else if ("aiExceptionFiltered" === res) {
            res = this.context.getTranslation("openAI", "aiExceptionFiltered")
        } else if ("tokenExceeded" === res) {
            res = this.context.getTranslation("openAI", "tokenExceeded")
        }
        this.setState({ aiAssistantAnswer: res, loadingOpenAI: false });
    }

    render() {
        return (
            <div>
                <Stack horizontal>
                    <Stack.Item style={{ marginTop: "5px", marginRight: "5px" }}>
                        <Stack>
                            {!this.props.isOpen && <IconButton
                                iconProps={{ iconName: 'ChevronRight' }}
                                onClick={this.props.open}
                            />}
                            {this.props.isOpen && <IconButton
                                iconProps={{ iconName: 'ChevronDown' }}
                                onClick={this.props.close}
                            />}
                        </Stack>
                    </Stack.Item>
                        <AIAssistantIcon
                            theme={this.props.theme}
                            style={{ marginTop: "10px", marginRight: "5px" }}
                            height="20px"
                            color="new" />
                    <h4>Cora</h4>
                </Stack>
                {this.props.isOpen && <div>
                    <Stack horizontal horizontalAlign="center" style={{ marginTop: "15px", marginBottom: "15px" }}>
                        {!this.state.loadingOpenAI && <Stack horizontal>
                            <Stack.Item style={{ marginRight: (window.innerWidth < 600 ? "25px" : "35px") }}>
                                <AIAssistantIcon
                                    height={window.innerWidth < 500 ? "60px" : "80px"}
                                    color="new"
                                    theme={this.props.theme} />
                            </Stack.Item>
                            <Stack.Item>
                                <Stack>
                                    <Stack.Item>
                                        <h4>{this.context.getTranslation("compliance", "aIAssistantCardTitle")}</h4>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <h5>{this.context.getTranslation("compliance", "aIAssistantCardDescription1")}</h5>
                                        <h5>{this.context.getTranslation("compliance", "aIAssistantCardDescription2")}</h5>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack horizontal style={{ marginTop: "15px", marginBottom: "10px" }}>
                                            <AIAssistantQuestionsSelector
                                                isFromDetailView={true}
                                                automated={false}
                                                selectedKeys={this.state.aIAssistantSelectedQuestions}
                                                onChangeAIAssistantQuestions={this.onChangeAIAssistantQuestions}
                                                hasMultiselect={false}
                                                queryOnTemplateGroups={false}
                                                hasOpenQuestion={this.props.userRules.availableOpenQuestion}
                                                availableAIAssistants={this.props.userRules.availableAIAssistant}
                                                question={this.setQuestion}
                                                querySuccesful={this.queryHasFinished}
                                                userRules={this.props.userRules}
                                            />
                                            {this.state.aIAssistantSelectedQuestions != "-1" && this.state.dropdownQuerySuccesful && (
                                                <PrimaryButton
                                                    text={this.context.getTranslation("compliance", "aIAssistantCardButton")}
                                                    disabled={this.state.aIAssistantSelectedQuestions == ""}
                                                    onClick={this.askAssistant}
                                                />)}
                                        </Stack>
                                    </Stack.Item>
                                    {this.state.aIAssistantSelectedQuestions == "-1" && (<Stack.Item>
                                        <Stack horizontal style={{ marginTop: "15px", marginBottom: "10px" }}>
                                            <TextField /*style={{ width: "500px" }}*/ id="openQuestion"
                                                placeholder={this.context.getTranslation("compliance", "aIAssistantOpenQuestionPlaceholder")}
                                                value={this.state.openQuestion} onChange={() => {
                                                    this.setState({
                                                        openQuestion: event.target.value,
                                                        aiAssistantAnswer: ""
                                                    })
                                                }} />
                                            <PrimaryButton
                                                style={{ marginLeft: "15px" }}
                                                text={this.context.getTranslation("compliance", "aIAssistantCardButton")}
                                                disabled={this.state.aIAssistantSelectedQuestions == "" || this.state.openQuestion == ""}
                                                onClick={this.askAssistant}
                                            />
                                        </Stack>

                                    </Stack.Item>)}

                                </Stack>
                            </Stack.Item>

                        </Stack>
                        }
                        {this.state.loadingOpenAI && (
                            <Stack>
                                <Spinner label={this.context.getTranslation("compliance", "loadingAssistant")} ariaLive="assertive" labelPosition="top" />
                            </Stack>
                        )}

                    </Stack>
                    {/*Result AIAssistant*/}
                    {this.state.aiAssistantAnswer !== "" && <Stack horizontal horizontalAlign="center" style={{ margin: "30px" }}>
                        <Stack.Item>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                order: 5,
                                padding: '3px',
                                margin: '3px',
                                boxShadow: 'rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px',
                                //width: '760px',  // Same width as the TextField in previous example
                                maxWidth: '100%',  // Ensures it doesn't overflow the parent
                                minWidth: "300px"
                            }}>
                                <Stack>
                                    <Stack.Item style={{ marginLeft: "15px" }}><h5>{"Q: " + (this.state.openQuestion == "" ? this.state.aIAssistantQuestion : this.state.openQuestion)}</h5></Stack.Item>
                                    <Stack.Item style={{ marginLeft: "15px" }}>
                                        <h5 style={{ whiteSpace: 'pre-wrap' }}>{this.state.aiAssistantAnswer}</h5>
                                    </Stack.Item>
                                </Stack>
                            </div>
                        </Stack.Item>
                    </Stack>}
                    <AIDisclaimer theme={this.props.theme} />
                </div>
                }
            </div>

        )
    }
}